import React, { useState, useCallback } from "react";
import { signIn } from 'aws-amplify/auth';
import "./Welcome.css";
import { useNavigate } from "react-router-dom";
import logo from "../assets/CAROLINA.png";
import { BsCheckCircle, BsXCircle, BsInfoCircle } from "react-icons/bs";

function SignIn() {
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [toast, setToast] = useState({ show: false, message: '', type: '' });
    const showToast = useCallback((message, type = 'info') => {
        setToast({ show: true, message, type });
        setTimeout(() => {
            setToast({ show: false, message: '', type: '' });
        }, 4000);
    }, []);

    const signInHandle = async () => {
        if (!email.trim() || !password.trim()) {
            const msg = "Please enter both email and password.";
            setErrorMessage(msg);
            showToast(msg, "error");
            return;
        }
        try {
            await signIn({ username: email, password: password });
            navigate("/data");
        } catch (error) {
            let msg;
            if (error.message?.includes('already a signed in user')) {
                navigate("/data");
                return;
            }
            switch (error.message) {
                case 'Username should be either an email or a phone number.':
                    msg = "Please enter a valid email address.";
                break;
                case 'Password did not conform with policy: Password not long enough':
                    msg = "Password is not long enough.";
                break;
                default:
                    msg = "Authentication failed. Please check your credentials and try again.";
            }
            setErrorMessage(msg);
            showToast(msg, "error");
        }
    }

    return (
        <div id="root">
            {toast.show && (
                <div className={`toast toast-${toast.type}`} role="alert" aria-live="polite">
                    <div className="toast-content">
                        {toast.type === 'success' && <BsCheckCircle className="toast-icon" />}
                        {toast.type === 'error' && <BsXCircle className="toast-icon" />}
                        {toast.type === 'info' && <BsInfoCircle className="toast-icon" />}
                        <span>{toast.message}</span>
                    </div>
                </div>
            )}
            <div className="wrapper">
                <div className='container' id="content" >
                    <div className="md-3" id="messages">
                        <label className="contentTitle">Welcome Admin</label>
                    </div>
                    <div className="inputContainer" id="">
                        <div className="brandMark">
                            <img src={logo} alt="Carolina OMF Imaging" className="brandMarkIcon" />
                        </div>
                        { errorMessage && <div className="errorLog">
                            <p className="errorLog">{errorMessage}</p>
                        </div> }
                        <div>
                            <div>
                                <input id="email-input"
                                value={email}
                                placeholder="Email"
                                onChange={(ev) => setEmail(ev.target.value)}
                                className={'inputBox'}
                                required
                                />
                            </div>
                            <br />
                            <div>
                                <input id="pass-input"
                                type="password"
                                value={password}
                                placeholder="Password"
                                onChange={(ev) => setPassword(ev.target.value)}
                                onKeyDown={e => e.key === 'Enter' ? signInHandle() : ''}
                                className={'inputBox'}
                                required
                                />
                            </div>
                            <br />
                            <div id="cred_buttons" >
                                <div>
                                    <button type="button" onClick={signInHandle} value={'Log in'} className="logInButton">Log In</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="footer">
                    </div>
                </div>
            </div>
        </div>
    );
}

export default SignIn;